import MSGraphService from '@/services/msgraph.service'

export default {
  namespaced: true,
  state: {
    user: {}
  },
  getters: {
    CURRENTUSER: state => {
      return state.user
    },
    DISPLAYNAME: state => {
      return state.user.displayName
    }
  },
  mutations: {
    SET_CURRENT_USER(state, payload) {
      state.user = payload
    }
  },
  actions: {
    async getMe({ commit }) {
      await MSGraphService.getMe()
        .then(u => {
          commit('SET_CURRENT_USER', u)
        })
        .catch(e => {
          this.msg = 'TCL: getMe -> e' + e
        })
    }
  }
}
